window.ModeTablePrematch = (function () {

    const selectors = {
        betPlace: '#bet-place',
        table: '.events-table',
        tbHeader: '.events-table__header',
        resultsLine: '[tb-resline]',
        event: '.events-table__body-row',
        eventTitle: '.events-table__title',
		eventAllCoefsCount: '.events-table__all-coefs-count',
        expandAllCoefsButton: '.js-expand-all-coefs',
        cell: '.events-table__markets-cell',
        scrollbarContentWrapper: '.m-page-content-scrollbar > .awesome-scrollbar__content-wrapper',

        eventCoefs: '.events-table__row-coefs',
        oeCell: '.event-markets__coef',
        oeList: '#oe-market_list',
        oeMarket: '.event-markets__item',
    };

    const topHeight = {
        bannerHeight: $('#mobile-app-banner').height(),
        headHeight: $('#app-header').height(),
        headerWithBanner: null
    };
    topHeight.headerWithBanner = topHeight.bannerHeight + topHeight.headHeight;

    var Table = (function () {
        var Table = function (domTable) {
            this.domTable = domTable;

            this.id = this.domTable.data('id');
            this.isExpanded = this.domTable.hasClass('m-expanded');

            if (this.isExpanded) {
                this.header = this.domTable.find(selectors.tbHeader);
                this.showHighlightBtn = this.domTable.find('[prematch-show-highlight-popup]');

                this.setHighlightingAvaliability();
                this.hType = this.getConfig().hType || 'None';
                this.highlight();

                this.bindUI();
            }
        };

        Table.prototype.getConfig = function () {//TODO: слишком много лишнего чтения стораджа при нескольких таблицах. поднять общий конфиг на уровень выше.
            var storageData = sessionStorage.getItem('tableConfig'),
                tableConfig = {};

            if (storageData) {
                storageData = JSON.parse(storageData);

                if (storageData.hasOwnProperty(this.id))
                    tableConfig = storageData[this.id];
            }

            return tableConfig;
        }

        Table.prototype.setConfig = function (data) {
            var storageData = sessionStorage.getItem('tableConfig');

            if (storageData) {
                storageData = JSON.parse(storageData);
            } else {
                storageData = {};
            }

            storageData[this.id] = data;
            sessionStorage.setItem('tableConfig', JSON.stringify(storageData));
        }

        Table.prototype.updateConfig = function (data) {
            var tableConfig = this.getConfig();

            for (key in data) {
                tableConfig[key] = data[key];
            }

            this.setConfig(data);
        }

        Table.prototype.setHType = function (hType) {
            this.updateConfig({
                hType: hType
            });
            this.hType = hType;
        };

        Table.prototype.bindUI = function () {
            var self = this;


            this.showHighlightBtn.off('click').on('click', function () {
                if (window.Highlight) {

                    window.Highlight.show($(this), self.hType, function (newHType) {
                        self.setHType(newHType);
                        self.highlight();
                    });

                }
            });

        };

        Table.prototype.extend = function () {
            this.setHighlightingAvaliability();
            this.hType = this.getConfig().hType || 'None';
            this.highlight();
        };

        Table.prototype.shrink = function () {
            this.setHighlightingAvaliability();
        }

        Table.prototype.collapse = function () {
            this.header.css({
                transform: 'translateY(0)'
            });
            delete this.header;
            delete this.showHighlightBtn;
        };

        Table.prototype.highlight = function () {
            const _str1 = '1', _strX = 'x', _str2 = '2', _strT = window.Localization.getString('Scripts_Shared_Main.ModeTablePrematch_12', 'тотал'), _strB = window.Localization.getString('Scripts_Shared_Main.ModeTablePrematch_13', 'бол'), _strM = window.Localization.getString('Scripts_Shared_Main.ModeTablePrematch_14', 'мен');
            const _favHas1x2Ceil = 1.8, _favHas12Ceil = 1.5, _cleFavHas1x2Ceil = 1.4, _cleFavHas12Ceil = 1.2, _highLowCeil = 1.5;
            var self = this;

            if (self.domTable.hasClass('m-collapsed'))
                return false;

            self.domTable.find('.hl').removeClass('hl');
            procTypeGroup();

            function procTypeGroup() {
                if (self.hType === 'None')
                    return false;

                var cols = self.domTable.find(selectors.resultsLine + ' ' + selectors.cell);
                if (!cols.length)
                    return false;

                var events = self.domTable.find('.mode-table__body .mode-table__center-col--inner');
                events.each(function () {
                    procEvent($(this));
                });


                function procEvent(event) {
                    var has1x2 = has12 = hasTBM = false;
                    if (self.hType == 'Favorites' || self.hType == 'ClearFavorites') {
                        var h1 = hx = h2 = false;
                        cols.each(function () {
                            var col = $(this);
                            var colH = col.text().trim().toLowerCase();
                            var is1 = (colH == _str1), isx = (colH == _strX), is2 = (colH == _str2);
                            if (is1 || isx || is2) {
                                var res = event.find(selectors.cell).eq(col.index());
                                if (res && res.attr('data-oid')) {
                                    if (is1) h1 = true;
                                    else if (isx) hx = true;
                                    else h2 = true;
                                }
                            }
                        });
                        has1x2 = (h1 && hx && h2);
                        has12 = (h1 && !hx && h2);
                    }
                    else {
                        var hb = hm = false;
                        cols.each(function () {
                            var col = $(this);
                            var colH = col.text().trim().toLowerCase();
                            var isB = (colH == _strB), isM = (colH == _strM);
                            if (isB || isM) {
                                var res = event.find(selectors.cell).eq(col.index());
                                if (res && res.attr('data-oid') && res.attr('data-coefvalue') != '-') {
                                    if (isB) hb = true;
                                    else hm = true;
                                }
                            }
                        });
                        hasTBM = (hb && hm);
                    }

                    event.find(selectors.cell).each(function () {
                        procCoef($(this));
                    });

                    function procCoef(coef) {
                        if (!coef.attr('data-oid'))
                            return false;
                        var colTitle = cols.eq(coef.index()).text().trim().toLowerCase();
                        var coefVal = parseFloat(coef.attr('data-coefvalue'));
                        if (isNaN(coefVal))
                            return;

                        switch (self.hType) {
                            case 'Favorites':
                                {
                                    if (has12 || has1x2) {
                                        var ceiling = (has1x2) ? _favHas1x2Ceil : _favHas12Ceil;
                                        var is12 = (colTitle == _str1 || colTitle == _str2);
                                        if (is12 && coefVal <= ceiling)
                                            hltCoef();
                                    }
                                    break;
                                }
                            case 'ClearFavorites':
                                {
                                    if (has12 || has1x2) {
                                        var ceiling = (has1x2) ? _cleFavHas1x2Ceil : _cleFavHas12Ceil;
                                        var is12 = (colTitle == _str1 || colTitle == _str2);
                                        if (is12 && coefVal <= ceiling)
                                            hltCoef();
                                    }
                                    break;
                                }
                            case 'HighMatches':
                                {
                                    if (hasTBM && (colTitle == _strB) && coefVal <= _highLowCeil)
                                        hltCoef();
                                    break;
                                }
                            case 'LowMatches':
                                {
                                    if (hasTBM && (colTitle == _strM) && coefVal <= _highLowCeil)
                                        hltCoef();
                                    break;
                                }
                        }

                        function hltCoef() {
                            coef.addClass('hl');
                        }
                    }
                }
            }
        };

        Table.prototype.setHighlightingAvaliability = function () {
            (this.domTable.find(selectors.event).length) ? this.showHighlightBtn.removeClass('m-disabled') : this.showHighlightBtn.addClass('m-disabled');
        };

        return Table;
    }());

    //----------------------------------------------------

    var tables = {},
        pageContentScrollTop = 0;

    function removeFromCart(oId) {
        window.ClientCart.removeOutcome(Number(oId));
    }

    function addToCart(sData) {
        window.ClientCart.addOutcome({
            oId: Number(sData.oId),
            eId: Number(sData.eId),
        });
    }

    function bindUI() {

        // Fix Header v3.0
        if (app.isIE()) {
            $(selectors.scrollbarContentWrapper).on('scroll.prematchTable', function () {
                pageContentScrollTop = $(this).scrollTop();
                fixHeader(pageContentScrollTop);
            });
        }

		// Expand Event coefs v3.0
        app.body.on('click', selectors.expandAllCoefsButton, function () {
            var eventNode = $(this).closest(selectors.event),
                coefsNode = eventNode.find(selectors.eventCoefs);

            if (globalAppSettings.isMobileDevice && !globalAppSettings.isMobileDeviceInDesktopMode) {

                if ($('#mobile-app-banner').css('display') == 'none') {
                    $('.events-table__row-main-info').css('top', topHeight.headHeight);
                    eventNode.attr('data-filter-sticky', 'ordinaryTop');
                } else {
                    $('.events-table__row-main-info').css('top', topHeight.headerWithBanner);
                    eventNode.attr('data-filter-sticky', 'topWithBanner');
                }
            }


            if (coefsNode.data('loaded') !== undefined) {
                eventNode.toggleClass('m-expanded');


                if (eventNode.hasClass('m-expanded')) {
                    let scrollEvent = $(window).scrollTop();

                    eventNode.data('node-saved-top', scrollEvent);
                } else {
                    let defaultPosition = eventNode.data('node-saved-top');
                    let scrollEvent = $(window).scrollTop();
                    if (defaultPosition == undefined) {
                        defaultPosition = scrollEvent;
                    };
                    let deltaScroll = defaultPosition - scrollEvent; //direction scrollTop
                    let positionEventBeforeCollapse = $(eventNode).offset().top;

                    //scrollDefaultPosition
                    if (globalAppSettings.isMobileDevice && !globalAppSettings.isMobileDeviceInDesktopMode) {

                        if ((deltaScroll < 0) && (scrollEvent > defaultPosition) && (scrollEvent > positionEventBeforeCollapse)) {
                            if ($('#mobile-app-banner').css('display') == 'none') {
                                $(window).scrollTop(eventNode.offset().top - topHeight.headHeight);
                            } else {
                                $(window).scrollTop(eventNode.offset().top - topHeight.headerWithBanner);
                            }
                        } else if (deltaScroll > 0 || scrollEvent < positionEventBeforeCollapse) {
                            $(window).scrollTop(scrollEvent);
                        } else {
                            $(window).scrollTop(defaultPosition);
                        }
                    }
                }
                return false;
            }

            if (id = eventNode.data('id')) {
                eventNode.addClass('m-expanded m-loading');
                Ajax.postJson("/Prematch/ShowEventCoefs", {
                    data: {
                        id: id,
                    },
                    doCallAjaxViewParsers: false,
                    success: function (resp) {
                        coefsNode.replaceWith(resp.html);
                        eventNode.removeClass('m-loading');

                        document.dispatchEvent(new CustomEvent('showEventsListCoefs', {
                            detail: {
                                openedEventsIdsWithMarketKind: new Map([[parseInt(id), undefined]])
                            }
                        }));
                    }
                });

                let scrollEvent = $(window).scrollTop();

                eventNode.data('node-saved-top', scrollEvent);
            }
            return false;
        });

        // Betting cart TableLine (add/remove) v3.0
        app.body.on('click', selectors.cell + '[data-aid]', function () {
            var that = $(this),
                coefOid = that.attr('data-oid');

            if (that.hasClass('active')) {
                removeFromCart(coefOid);
                that.removeClass('active');
                return false;
            }

            var event = that.closest(selectors.event),
                eventTitle = event.find(selectors.eventTitle).first().text().trim(),
                eventId = event.attr('data-id'),
                coefVal = that.attr('data-coefvalue'),
                coefAid = that.attr('data-aid');

            if (that.hasClass('blocked') || event.hasClass('blocked') || coefVal === '-')
                return false;

            var resTitleNodes = that.closest(selectors.table).find(selectors.resultsLine + ' [data-ctid]'),
                resTitleNode = resTitleNodes.eq(that.index()),
                resTitle = resTitleNode.text().trim(),
                lowResTitle = resTitle.toLowerCase(),
                smTitle = resTitleNode.attr('data-sm'),
                complexResTitle = '',
                period = '';

            if (resTitleNode.attr('data-dvd') !== undefined) { //рынки с периодом/сэтом
                periodIndex = resTitleNodes.filter('[data-sm="' + smTitle + '"]').first().index();
                period = ' (' + event.find(selectors.cell).eq(periodIndex).text().trim() + ')';
            }

            if (lowResTitle === window.Localization.getString('Scripts_Shared_Main.ModeTablePrematch_14', 'мен') || lowResTitle === window.Localization.getString('Scripts_Shared_Main.ModeTablePrematch_13', 'бол')) { //рынок ТОТАЛ
                offset = (lowResTitle === window.Localization.getString('Scripts_Shared_Main.ModeTablePrematch_14', 'мен')) ? 2 : 1;
                var totalVal = event.find(selectors.cell).eq(that.index() - offset).attr('data-coefvalue');
                complexResTitle = smTitle + '(' + resTitle + '(' + totalVal + '))';
            }
            else if (lowResTitle === window.Localization.getString('Scripts_Shared_Main.ModeTablePrematch_15', 'кф')) {  //рынок ФОРА
                var fkTitle = resTitleNodes.eq(that.index() - 1).text().trim();
                var fkVal = event.find(selectors.cell).eq(that.index() - 1).attr('data-coefvalue');
                complexResTitle = smTitle + ' (' + fkTitle + '(' + fkVal + ')' + ') ' + resTitle;
            }
            else { //простые рынки
                complexResTitle = smTitle + ' (' + resTitle + ')';
            }
            complexResTitle += period;

            var sData = {
                oId: coefOid,
                aId: coefAid,
                eId: eventId,
                eTitle: eventTitle,
                rTitle: complexResTitle,
                val: coefVal,
                isLive: false
            }
            //alert(JSON.stringify(sData));

            // return false if cart is sending now or overflowed, return true if added or already added.  Blink on false
            addToCart(sData);
            return false;
        });

        // Betting cart MarketList (add/remove) v3.0
        app.body.on('click', selectors.oeCell + '[data-aid]', function () {
            var that = $(this);

            if (that.hasClass('active')) {
                var oid = that.attr('data-oid');
                removeFromCart(oid);
                that.removeClass('active');
            } else {

                var event = that.closest(selectors.event),
                    eventTitle = event.find(selectors.eventTitle).first().text().trim(),
                    eventId = event.attr('data-id');

                var market = that.closest(selectors.oeMarket),
                    list = $(selectors.oeList);

                if (that.hasClass('m-blocked') || market.hasClass('m-blocked') || list.hasClass('m-blocked'))
                    return;

                var sData = {
                    oId: that.attr('data-oid'),
                    aId: that.attr('data-aid'),
                    eId: eventId,
                    eTitle: eventTitle,
                    rTitle: market.find('.event-markets__title').text() + ' (' + that.find('.event-markets__coef-title').attr('title') + ')',
                    val: that.find('.event-markets__coef-value').attr('data-coefvalue'),
                    isLive: false
                }
                // alert(JSON.stringify(sData));

                addToCart(sData);
            }
            return false;
        });

    }

    function unBindUI() {
        app.body
            .off('click', selectors.expandAllCoefsButton)
            .off('click', selectors.cell + '[data-aid]')
            .off('click', selectors.oeCell + '[data-aid]');

        if (app.isIE()) {
            $(selectors.scrollbarContentWrapper).off('scroll.prematchTable');
        }
    }

    function createTables() {
        $(selectors.table).each(function () {
            var self = $(this);
            var id = self.attr('data-id');
            if (id !== undefined)
                tables[id] = new Table(self);
        });
    }

    function destroyTables() {
        for (var key in tables) {
            tables[key].domTable.remove();
            delete tables[key];
        }
    }

	function init() {
		createTables();
		setTimeout(function () {
			$(selectors.scrollbarContentWrapper).scrollTop(sessionStorage.getItem('prematchPageContentScrollTop') || 0)
		}, 0);
        bindUI();
    }

    function dispose() {
		unBindUI();
        sessionStorage.setItem('prematchPageContentScrollTop', pageContentScrollTop);
        destroyTables();
    }

    function update () {
        destroyTables();
        createTables();
    };

    function updateTable (id) {
        delete tables[id];
        var self = $(selectors.table + '[data-id=' + id + ']');
        if (self.length === 0)
            return;
        tables[id] = new Table(self);
        $(selectors.scrollbarContentWrapper).scroll();
    }

    function extendTable(id) {
        if (tables.hasOwnProperty(id))
            tables[id].extend();
       // $(selectors.scrollbarContentWrapper).scroll();
    }

    function shrinkTable (id) {
        if (tables.hasOwnProperty(id))
            tables[id].shrink();
    }

    function collapseTable (id) {
        if (tables.hasOwnProperty(id))
            tables[id].collapse();
    }

    function removeTable (id) {
        if (tables.hasOwnProperty(id)) {
            tables[id].domTable.remove();
            delete tables[id];
        }
    }

    function insertTable (html, insertAfterId) {
        var self = $(html);
        var id = self.data('id');
        removeTable(id);

        if (insertAfterId !== undefined && tables.hasOwnProperty(insertAfterId))
            self.insertAfter(tables[insertAfterId].domTable);
        else
            $(selectors.betPlace).prepend(self);

        tables[id] = new Table(self);
    }


    //-------------------------------------------------------------

    var fixHeader = function (scrollTop) {
        for (key in tables) {
            var table = tables[key];

            if (table.header === undefined)
                continue;

            var top = table.domTable.position().top + parseInt(table.domTable.css('margin-top')) + 10;
            var height = table.domTable.outerHeight();

            if (scrollTop > top && scrollTop < top + height - 25) {
                table.header.css({
                    transform: 'translateY(' + (scrollTop - (top + 2)) + 'px)'
                });
            } else {
                table.header.css({
                    transform: 'translateY(0)'
                });
            }
        }
    }

    return {
        'tables': tables,
		'isEmpty': function () { return Object.keys(tables).length === 0 },
        'count': function() { return Object.keys(tables).length },
        'init': init,
        'dispose': dispose,
        'update': update,
        'extendTable': extendTable,
        'shrinkTable': shrinkTable,
        'updateTable': updateTable,
        'collapseTable': collapseTable,
        'removeTable': removeTable,
        'destroyTables': destroyTables,
        'insertTable': insertTable,
    };
}());



